<template>
  <div>
    <spacer :y="15"/>
    <div>
      <img :class="$style.logo" src="@/assets/images/logo_vertical.png" alt="logo">
    </div>
    <spacer :y="5"/>
    <h2 :class="$style.title">{{ isFirstTime ? 'パスワード設定' : 'パスワードリセット' }}</h2>
    <spacer :y="3"/>
    <div v-if="invalid">
      <p :class="$style.message">アクティベートキーが無効です。<br>再度パスワード再設定リクエストを送信してください。</p>
      <spacer :y="2"/>
      <div :class="$style.wrap">
        <router-link
        to="/forgot-password/"
        :class="$style.btn">再設定リクエスト</router-link>
      </div>
    </div>
    <div v-if="!invalid">
      <p
        :class="$style.message"
        v-if="!flag.sended">新しいパスワードを入力・送信してください。</p>
      <p
        :class="$style.message"
        v-if="flag.sended
          && flag.expired
          && !flag.updated">パスワード再設定の有効期限が切れています。再度<router-link to="/forgot-password/" class="link">こちら</router-link>からパスワード再設定リクエストをお送りください。</p>
      <p
        :class="$style.message"
        v-if="flag.sended
          && !flag.expired
          && !flag.updated">パスワードアップデートのためのアクティベートキーが無効です。<br>再度<router-link to="/forgot-password/" class="link">こちら</router-link>からパスワード再設定リクエストをお送りください。</p>
      <p
        :class="$style.message"
        v-if="flag.sended
          && flag.updated">パスワードを更新しました。<br><router-link to="/login/?isResetPass=true" class="link">こちら</router-link>からログインしてください。</p>
    </div>
    <spacer :y="3"/>
    <form
      v-if="!invalid && !flag.updated"
      v-on:submit="submit"
      autocomplete="off">
      <div :class="$style.form">
        <div :class="$style.input">
          <input
            id="password"
            :type="showPassword ? 'text' : 'password'"
            name="password"
            placeholder="パスワード"
            :class="[$style.password_field, { input_error: validationFlags.password }]"
            v-model.trim="$v.password.$model"
            v-on:input="invalidsCheck('password', $v.password.$invalid)"
            >
          <i
            :class="[$style.toggle_password, showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye']"
            @click="showPassword = !showPassword"
            ></i>
          <p
            :class="$style.comment"
            v-if="$v.password.$dirty
              && $v.password.required.$invalid">パスワードを入力してください</p>
          <p
            :class="$style.comment"
            v-if="$v.password.$dirty
              && $v.password.minLength.$invalid">パスワードは8文字以上で設定してください</p>
          <p
            :class="$style.comment"
            v-if="$v.password.$dirty
              && $v.password.maxLength.$invalid">パスワードは15文字以下で設定してください</p>
        </div>
        <spacer :y="3"/>
        <div :class="$style.wrap">
          <button
            type="submit"
            class="btn btn__primary sm"
            :class="$style.btn"
            v-bind:disabled="!submitFlag">送信</button>
        </div>
      </div>
    </form>
    <spacer :y="15"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, minLength, maxLength } from '@vuelidate/validators';
import Spacer from '@/views/components/Spacer.vue';
import cf from '@/mixins/commonFunctions';

export default {
  name: 'reset-password',
  mixins: [cf],
  components: {
    Spacer,
  },
  data() {
    return {
      validationFlags: {
        password: false,
      },
      // 無効フラグ
      invalids: {
        password: true,
        minLength: true,
      },
      // パラメータなし等で無効
      invalid: true,
      // 副管理者の初回パスワード設定リンク(&first=1)か一般の忘失リセットかの出し分け
      isFirstTime: false,
      activatekey: null,
      flag: {
        sended: false,
        updated: false,
        expired: false,
      },
    };
  },
  created() {
    // パラメータが含まれているか確認
    const query = this.$route.query;
    if (query.secret) {
      this.invalid = false;
      this.activatekey = query.secret;
    }
    // 副管理者の招待リンクは &first=1 付き＝初回パスワード設定。見出し/タブを「設定」に出し分ける
    // （リンクは直開き・ログイン前のため router meta の title が確定せず、当画面で document.title を明示）
    if (query.first) {
      this.isFirstTime = true;
      document.title = 'パスワード設定 | Welcome to talk';
    }
  },
  setup() {
    const password = ref('');
    const showPassword = ref(false);

    const rules = {
      // パスワードは必須で8文字以上15文字以下
      password: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(15),
      },
    };

    const $v = useVuelidate(rules, { password });
    return {
      password,
      showPassword,
      $v,
    };
  },
  computed: {
    ...mapState(['user', 'page']),
    submitFlag() {
      // 無効フラグが全てfalseならばtrueを返却
      return !this.invalids.password && !this.flag.updated && !this.flag.expired;
    },
  },
  methods: {
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },
    /** ローディング表示（送信〜サーバ応答まで全画面オーバーレイで操作不可にする） */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング非表示 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },
    submit(e) {
      e.preventDefault();
      // validateチェックは入力時に行われてる
      const data = {
        password: this.password,
        activatekey: this.activatekey,
      };

      // 送信ボタン押下〜サーバ応答までローディングを出し二重送信・画面操作を防ぐ
      this.showLoading();
      this.axios({
        method: 'POST',
        url: '/v1/user/resetPassword',
        data,
      })
        .then((response) => {
          const resData = response.data;
          if (resData.updated) this.flag.updated = true;
          cf.deleteLocalStorage('wtt', 'loginRef');
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            if (error.response.data.expired) this.flag.expired = true;
          } else console.log(error);
        })
        .finally(() => {
          this.flag.sended = true;
          this.hideLoading();
        });
    },
  },
};
</script>

<style lang="scss" module>
.wrap {
  display: flex;
  justify-content: center;
}
.logo {
  margin: 0 auto;
  width: 300px;
  max-width: 100%;
}
.title {
  text-align: center;
  color: var(--orange-main);
}
.form {
  text-align: center;
}
.input {
  margin: 0 auto;
  width: 400px;
  max-width: 100%;
  position: relative;
  input {
    width: 100%;
    padding: 13px;
    border-radius: 8px;
    border: none;
    background-color: var(--gray-sub);
    outline: none;
  }
}
.password_field {
  padding-right: 45px !important;
}
.toggle_password {
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
  cursor: pointer;
  color: #999;
  font-size: 18px;
}
.comment {
  font-size: 12px;
  color: var(--pink);
}
.message {
  font-size: 12px;
  text-align: center;
  // PW設定/リセット完了文中の「こちら」リンクが小さく目立たない指摘(#1)への対応。
  // 本文(黒・12px)から際立たせるため サイズUP＋ブランド主色＋太字＋下線で視認性を上げる。
  a {
    font-size: 16px;
    font-weight: bold;
    color: var(--orange-main);
    text-decoration: underline;
  }
}
.btn {
  display: inline-block;
  border-radius: 22px;
  border: none;
  background-color: #666;
  font-weight: bold;
  color: #fff;
  appearance: none;
  padding: 8px 25px;
  font-size: 16px;
}
</style>
